import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { addNewBankCard } from 'services/bankManagements'
interface IPayload {
    cardNumber: string
    isIban: boolean
}
export default function useSetAddCard(
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
) {
    const { isLoading, mutate, data } = useMutation({
        mutationFn: (payload: IPayload) => {
            return addNewBankCard(payload.cardNumber, payload.isIban)
        },
        onSuccess: (_, variables) => {
            setIsOpen(true)
        },
        onError: () => {
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutate, data }
}
